'use client';

import { useTokensStore } from '@/src/store/global/index';
import { useEffect, useState } from 'react';

const useIntervalEffect = (callback: () => void) => {
    useEffect(() => {
        const interval = setInterval(() => {
            callback(); // ✅ Executes the function every second
        }, 1000);

        return () => clearInterval(interval); // ✅ Cleanup when component unmounts
    }, []);
};

export const useServerTime = () => {
    //--------------------------------------
    const tokensStore = useTokensStore();
    // const [serverTime, setServerTime] = useState(0);
    // const [isServerTimeLoaded, setIsServerTimeLoaded] = useState(false);
    // const [swLoopWasAlreadyWorking, setSwLoopWasAlreadyWorking] = useState(false);
    //--------------------------------------
    const [count, setCount] = useState(0);
    useIntervalEffect(() => {
        const serverTime = tokensStore.getServerTime();
        // console.log('Loop running:', count, ' - Server Time:', serverTime);
        setCount((prev) => prev + 1);
    });

    // useEffect(() => {
    //     const fetchTime = async () => {
    //         if (tokensStore.serverTime !== undefined) {
    //             // console.log('Server Time:', tokensStore.serverTime);
    //             setServerTime(tokensStore.serverTime);
    //             setIsServerTimeLoaded(true);
    //         }
    //     };
    //     fetchTime();
    // }, [tokensStore.serverTime]);
    //--------------------------------------
    // useEffect(() => {
    //     if (tokensStore.intervalIdForUpdateLoop !== undefined) {
    //         setSwLoopWasAlreadyWorking(true);
    //     } else {
    //         tokensStore.beginUpdateLoop({ doUpdatePricesAutomatically: false });
    //     }
    //     return () => {
    //         if (swLoopWasAlreadyWorking === false) {
    //             tokensStore.stopUpdateLoop({ cancelFollowUp: false });
    //         }
    //     };
    // }, []);
    //--------------------------------------
    return {
        serverTime: tokensStore.serverTime,
        isServerTimeLoaded: tokensStore.isServerTimeLoaded,
    };

    //--------------------------------------
};
